<template>
    <app-base-main parentTable>
      <template #filter-group>
        <app-filter-group @reset="$gjReset" @query="$gjNoticeQuery">
          <gj-warehouse-select
              v-model="filter.warehouseIds"
              multiple
              :self="false"
              placeholder="仓库"
              width="180px"
          ></gj-warehouse-select>
          <gj-select
              :options="SELECT.TYPE_ALL"
              type="multi-check"
              :filterable="false"
              placeholder="全部类型"
              width="140px"
              v-model="filter.batchType"
          ></gj-select>
          <gj-select
              :options="SELECT.STATUS_ALL"
              type="multi-check"
              :filterable="false"
              width="130px"
              placeholder="状态"
              v-model="filter.status"
          ></gj-select>
          <gj-select-date-picker
              class="main-gj-select-date-picker"
              type="daterange"
              :width="['155px']"
              v-model="filter.date"
              :options="options.date"
          ></gj-select-date-picker>
          <gj-input
            v-model="filter.msku"
            placeholder="MSKU"
            width="180px"
            :matching.sync="filter.matchType"
            ></gj-input>
          <gj-select-input
              v-model="filter.keyword"
              :options="SELECT.SELECT_INPUT"
              :width="['120px', '180px']"
          ></gj-select-input>
        </app-filter-group>
      </template>
      <template #operate-group>
        <gj-button v-if="$permission('storageCostBatch:updateCostBatch')" type="primary" @click="replacementCost">重置成本
        </gj-button>
        <gj-button v-if="$permission('storageCostBatch:recalculate')" @click="recalculation">重算</gj-button>
        <gj-button v-if="$permission('storageCostBatch:shipSupplement')" @click="deliverySupplement">发货补录</gj-button>
      </template>
      <template #tool-group>
        <gj-tool-group
            :download="$permission('storageCostBatch:export')"
            download-url="/supply/storageCostBatch/export"
            :download-params="globalParams"
            setting :table-name="tableName" :table-columns="columns" :sort-gjtable="$refs.gjTable"
            help
            task :task-tip="taskProgressNumber" @clickTask="reloadTaskNumber"
            log @viewLog="viewLog({id: null})">
          <template #task-content>
            <TaskBatchManagement ref="task"/>
          </template>
          <template #before>
          <el-checkbox  v-model="costIsZeroFlag" @change="$gjNoticeQuery">
            成本为0的批次
          </el-checkbox>
        </template>
        </gj-tool-group>
      </template>
      <template #table>
        <gj-table
            ref="gjTable"
            adaptParent
            size="has-picture"
            show-summary
            show-overflow
            selection
            :index="false"
            :name="tableName"
            :data="tableData"
            :columns="columns"
            :loading="loading"
            :summary-object="summaryObject"
            :pagination="pagination"
            :default-sort="defaultSort"
            @sort-change="$gjSortChange"
            @page-change="$gjNoticeQuery">
          <!-- 自定义cell -->
          <template v-slot:op="{ row }">
            <gj-button-group
                type="dropdown-op"
                :config="opBtnConfig(row)"
            ></gj-button-group>
          </template>
          <template v-slot:statusName="{ row }">
            <gj-tag type="plain" :color="getColor(row.status)">{{ row.statusName }}</gj-tag>
            <!--          <div class="status-base" :class="`status-${row.status}`">{{ row.statusName }}</div>-->
          </template>
          <template v-slot:warehouseName="{ row }">
            <gj-tooltip :content="row.warehouseName" :text-line="2">
              {{row.warehouseName | defaultShow}}
            </gj-tooltip>
          </template>
        </gj-table>
      </template>
      <template #base-content>
        <novice-guide ref="noviceGuide"></novice-guide>
        <new-user-guide v-if="userGuideState" ref="newUserGuide"></new-user-guide>
      </template>
    </app-base-main>
</template>

<script>
import {convertToDate} from "@/utils/date.util.js"
import {isMeaningfulMixin, queryMixin, selectionMixin, userGuideMixin} from "@/minxins";
import {storageCostBatchPage, storageCostBatchRecalculateNum} from "@/api/finance.js";
import {SELECT, SELECT_WAREHOUSE} from "./config.js";
import TaskBatchManagement from "modules/finance/batch-management/components/task/task-batch-management.vue";
import Recalculation from "./components/Recalculation.vue";
import {amount} from "@/filters"
import {tagColors} from "@/components/tag/tag-colors";
import NoviceGuide from "./components/modal/novice-guide"
import NewUserGuide from "./components/new-user-guide"

export default {
  mixins: [queryMixin, selectionMixin, isMeaningfulMixin,userGuideMixin],
  name: "app-batch-management",
  inject: ['setPublicData'],
  components: {TaskBatchManagement, NoviceGuide, NewUserGuide},
  data() {
    return {
      tagColors,
      SELECT,
      defaultSort: {prop: 'marketTime', order: 'descending'},
      loading: false, // 加载
      initDisabled: true,
      transportOption: [],
      taskProgressNumber: null,
      summaryObject: null,
      tableName: "batch-management-main-v1.7.0",
      tableData: [], // 表格数据
      cacheOptions: {
        useCache: true,
      },
      options: {
        date: [
          {id: "1", text: "入库日期(站点时区)"},
          {id: "2", text: "入库日期(北京时间)"}
        ]
      },
      filter: {
        batchType: [],
        status: [],
        warehouseIds: [],
        date: {
          key: '1',
          value: [],
        },
        keyword: {
          key: "relevanceCode",
          value: "",
        },
        msku: null,
        matchType: 'like'
      },
      columns: [
        {
          id: 'warehouseName',
          fixed: "left",
          header: '仓库',
          field: 'slot:warehouseName',
          minWidth: '120px',
          default: true,
          disabled: true
        },
        {
          id: 'batchNumber',
          fixed: "left",
          header: '批次号',
          field: 'batchNumber',
          minWidth: '145px',
          default: true,
          disabled: true
        },
        {id: 'picture', header: '图片', field: 'picture:imageUrl', width: '60px', default: true, disabled: true},
        {id: 'msku', header: 'MSKU', field: 'msku', minWidth: '170px', default: true, disabled: true},
        {id: 'marketDate', header: '入库日期(站点时区)', field: 'marketDate', minWidth: '160px', default: true, sortable: true, sortBy: 'marketTime'},
        {id: 'beijingTime', header: '入库日期(北京时间)', field: 'beijingTime', minWidth: '160px', default: true, sortable: true},
        {id: 'statusName', header: '状态', field: 'slot:statusName', minWidth: '85px', default: true},
        {id: 'batchTypeName', header: '类型', field: 'batchTypeName', minWidth: '85px', default: true},
        {id: 'relevanceCode', header: '单据号', field: 'relevanceCode', minWidth: '170px', default: true},
        {id: 'shipmentId', header: '货件号', field: 'shipmentId', minWidth: '170px', default: true},
        {
          id: 'receiptQuantity',
          header: '数量',
          summary: true,
          align: 'right',
          field: 'receiptQuantity',
          minWidth: '125px',
          default: true
        },
        {
          id: 'usedQuantity',
          header: '扣除量',
          summary: true,
          align: 'right',
          field: 'usedQuantity',
          minWidth: '125px',
          default: true
        },
        {
          id: 'surplusQuantity',
          header: '剩余量',
          summary: true,
          align: 'right',
          field: 'surplusQuantity',
          minWidth: '125px',
          default: true
        },
        {
          id: 'purchaseCost',
          prefix: "purchaseCurrencySymbol",
          header: '采购成本',
          summary: true,
          align: 'right',
          field: 'purchaseCost',
          minWidth: '125px',
          default: true,
          scale: 4
        },
        {
          id: 'arrivalCost',
          prefix: "purchaseCurrencySymbol",
          header: '到库成本',
          summary: true,
          align: 'right',
          field: 'arrivalCost',
          minWidth: '125px',
          default: true,
          scale: 4
        },
        {
          id: 'totalPurchaseCost',
          prefix: "purchaseCurrencySymbol",
          header: '总采购成本',
          summary: true,
          align: 'right',
          field: 'totalPurchaseCost',
          minWidth: '140px',
          default: true,
          scale: 4
        },
        {
          id: 'totalArrivalCost',
          prefix: "purchaseCurrencySymbol",
          header: '总到库成本',
          summary: true,
          align: 'right',
          field: 'totalArrivalCost',
          minWidth: '140px',
          default: true,
          scale: 4
        },
        {
          id: 'totalCostValue',
          prefix: "purchaseCurrencySymbol",
          header: '总货值',
          summary: true,
          align: 'right',
          field: 'totalCostValue',
          minWidth: '140px',
          default: true,
          scale: 4
        },
        {id: 'op', header: '操作', field: 'slot:op', minWidth: '125px', fixed: "right", default: true,},
      ],
      opBtnConfig: (row) => [
        {
          label: '日志',
          click: () => this.viewLog(row)
        },
        {
          label: '扣减明细',
          show: () => this.$permission('storageCostBatchConsume:view'),
          click: () => this.deductionDetails(row)
        },
      ],
      costIsZeroFlag: false
    };
  },
  async created() {
    let res = await SELECT_WAREHOUSE(false)
    if (res && res.length != 0) {
      this.initDisabled = false
    }
  },
  mounted() {
    this.$nextTick(()=> {
      if(this.$permission('storageCostBatch:updateCostBatch') && this.$permission('storageCostBatch:recalculate') && this.$permission('storageCostBatch:shipSupplement')) {
        this.$refs.noviceGuide.openNotice()
      }
    })
  },
  methods: {
    getColor(status) {
      switch (status) {
        case 'deducting':
          return this.tagColors.blue
        case 'not_start':
          return this.tagColors.orange
        case 'already_deducted':
          return this.tagColors.lightGray
      }
    },
    $gjCacheCallback() {
      return {};
    },
    reloadTaskNumber() {
      this.storageCostBatchRecalculateNum()
      if (this.$refs && this.$refs.task) {
        this.$refs.task.$gjReset();
      }
    },
    // 初始化
    $gjQueryInitParams() {
      return {
        filter: {
          batchType: [],
          status: [],
          warehouseIds: [],
          date: {
            key: '1',
            value: [],
          },
          keyword: {
            key: "relevanceCode",
            value: "",
          },
          msku: null,
          matchType: 'like'
        },

      }
    },
    // 搜索
    $gjQuery() {
      // 构造查询参数
      const params = {
        model: {
          batchType: this.filter.batchType,
          status: this.filter.status,
          warehouseIds: this.filter.warehouseIds,
          beginCreateDate: null,
          endCreateDate: null,
          bjBeginCreateDate: null,
          bjEndCreateDate: null,
          accurateQuery: this.filter.matchType === 'exact',
          msku: this.filter.msku,
          costIsZeroFlag: this.costIsZeroFlag
        },
        ...this.queryPagination,
        ...this.querySort
      };
      params.model[this.filter.keyword.key] = this.filter.keyword.value;
      if (this.filter.date.value && this.filter.date.value.length !== 0) {
        if (this.filter.date.key === '1') {
          params.model.beginCreateDate = convertToDate(this.filter.date.value[0])
          params.model.endCreateDate = convertToDate(this.filter.date.value[1])
        } else {
          params.model.bjBeginCreateDate = convertToDate(this.filter.date.value[0])
          params.model.bjEndCreateDate = convertToDate(this.filter.date.value[1])
        }
      }
      this.globalParams = params;
      this.storageCostBatchPage(params)
      this.storageCostBatchRecalculateNum()
    },
    // 重算任务树
    async storageCostBatchRecalculateNum() {
      this.taskProgressNumber = await storageCostBatchRecalculateNum() || null

    },
    // 查询list数据
    async storageCostBatchPage(params) {
      this.loading = true
      try {
        let data = await storageCostBatchPage(params)
        this.pagination = this.getPagination(data);
        this.tableData = data.records || []
        this.summaryObject = data.statisticRecord || {};
        this.summaryObject.purchaseCost = this._.round(Number(this.summaryObject.totalPurchaseCost) / Number(this.summaryObject.receiptQuantity), 4);
        this.summaryObject.arrivalCost = this._.round(Number(this.summaryObject.totalArrivalCost) / Number(this.summaryObject.receiptQuantity), 4);
        this.summaryObject.purchaseCost = amount(this.summaryObject.purchaseCost, 4)
        this.summaryObject.arrivalCost = amount(this.summaryObject.arrivalCost, 4)
      } finally {
        this.loading = false
      }
    },
    disabledDate(time) {
      return time.getTime() > new Date().getTime(); // 限制今天以后
    },
    // 重置成本
    replacementCost() {
      if(this.selectedRows.length > 50){
        this.$gjMessage.warning('最多可选择50条数据进行重置成本!');
        return
      }
      this.setPublicData('state', 'replacement-cost')
      this.setPublicData('selectList', this.selectedRows)
    },
    // 重算
    recalculation() {
      this.$gjCreate(Recalculation, {
        props: {},
        on: {
          update: () => {
            // 重新获取任务数
            setTimeout(() => {
              this.storageCostBatchRecalculateNum()
            }, 500);
          }
        }
      });
    },
    // 发货补录
    deliverySupplement() {
      this.setPublicData('state', 'delivery-supplement')
    },
    // 扣减明细
    deductionDetails(row) {
      sessionStorage.setItem('batchNumber', row.batchNumber)
      this.$router.push({
        path: "/finance/deduction-record"
      })
    },
    // 操作日志
    viewLog(row) {
      this.$gjCreate('gj-log-modal', {
        props: {
          url: '/supply/storageCostBatchLog/page',
          opTypeOption: [
            {id: 'update', text: '更新'},
            {id: 'init', text: '初始化'},
            {id: 'init_history_batch', text: '生成历史批次'},
            {id: 'recalculate', text: '重算'},
          ],
          params: {
            model: row.id,
          }
        }
      });
    }
  },
};
</script>

<style scoped lang="scss">
.date-picker {
  width: 136px;
}

.status-base {
  width: 60px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  border-radius: 6px;
  font-size: 12px;
  color: #666666;
  background: #F6F6F8;
  border: 1px solid #D8DADD;
}

.status-not_start {
  color: #ED6A0C;
  border: 1px solid #ED6A0C;
  background: #FFF5ED;
}

.status-deducting {
  color: #1F6EEF;
  background: #EDF7FF;
  border: 1px solid #4994FC;
}

.status-already_deducted {
  color: #217930;
  background: #F0FAF2;
  border: 1px solid #66BE74;
}
</style>
